import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import PageHeader from '../../../../components/PageHeader';
import PageMenu from '../../../../components/PageMenu';
import PageMenuItem from '../../../../components/PageMenuItem';

// Screens.
import Conversations from './screens/Conversations';

/**
 * Help screen, for showing help for users.
 *
 * @extends React.Component
 */
class Help extends Component {
  render() {
    return (
      <div className="container-fluid">
        <PageHeader label="Hjælp" />
        <div className="row">
          <PageMenu header="Emner">
            <PageMenuItem label="Samtaler" href={`${this.props.match.path}/conversations`} />
          </PageMenu>
          <div className="col-sm-9">
            <div className="tab-content" id="nav-tabContent">
              <Switch>
                <Redirect exact from={`${this.props.match.path}`} to={`${this.props.match.path}/conversations`} />
                <Route exact path={`${this.props.match.path}/conversations`} component={Conversations} />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Help;



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/screens/Help/index.js